export interface ITrackingEvent {
	url: string;
	category: string;
	action: string;
	label: string;
	timeElapsed?: number;
	eventData?: string;
}
